import currencyJS from 'currency.js';
import { getAppConfig } from 'Core/config/appConfig';

export const formatCurrency = (
  value,
  {
    currency = getAppConfig().currency,
    currencyDisplay = 'symbol',
    withDecimals = true,
    roundUp = false,
  } = {}
) => {
  const decimalOptions = withDecimals
    ? {
        minimumFractionDigits: 2,
      }
    : {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      };

  return new Intl.NumberFormat(getAppConfig().locale, {
    style: 'currency',
    currency,
    currencyDisplay,
    ...(roundUp && { roundingMode: 'ceil' }),
    ...decimalOptions,
  }).format(value);
};

export function toFloat(value) {
  return currencyJS(value).value;
}
